// src/components/RoleSwitcher.js - Clean production version
import React from 'react';
import { db, auth } from '../firebase/config';
import { doc, updateDoc, getDoc } from 'firebase/firestore';

const RoleSwitcher = ({ currentUser }) => {
  const [switching, setSwitching] = React.useState(false);
  const [error, setError] = React.useState('');

  const availableRoles = React.useMemo(() => {
    if (!currentUser) return [];
    const roles = [currentUser.role];
    if (currentUser.secondaryRoles && Array.isArray(currentUser.secondaryRoles)) {
      currentUser.secondaryRoles.forEach(role => {
        if (!roles.includes(role)) {
          roles.push(role);
        }
      });
    }
    return roles;
  }, [currentUser]);

  const switchRole = async (newRole) => {
    if (!currentUser || !currentUser.docId) {
      setError('Cannot switch roles: user data not available');
      return;
    }

    setSwitching(true);
    setError('');

    try {
      // Prepare updated secondary roles
      const currentSecondaryRoles = currentUser.secondaryRoles || [];
      const updatedSecondaryRoles = [...currentSecondaryRoles];
      
      if (!updatedSecondaryRoles.includes(currentUser.role)) {
        updatedSecondaryRoles.push(currentUser.role);
      }

      const finalSecondaryRoles = updatedSecondaryRoles.filter(role => role !== newRole);

      // Update Firestore
      const userDocRef = doc(db, 'faculty_staff', currentUser.docId);
      const updateData = {
        role: newRole,
        secondaryRoles: finalSecondaryRoles,
        roleLastSwitched: new Date(),
        roleSwitchedBy: currentUser.uid
      };

      await updateDoc(userDocRef, updateData);

      // Wait for Cloud Function to process
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Refresh auth token
      await auth.currentUser.getIdToken(true);
      
      // Reload page to update sidebar and permissions
      window.location.reload();

    } catch (error) {
      console.error('Role switch error:', error);
      setError('Failed to switch role. Please try again.');
    } finally {
      setSwitching(false);
    }
  };

  // Don't render if user has only one role
  if (!currentUser || availableRoles.length <= 1) {
    return null;
  }

  return (
    <div style={{ padding: '10px 0' }}>
      <label style={{ 
        display: 'block', 
        marginBottom: '5px', 
        fontSize: '12px', 
        color: '#aaa' 
      }}>
        Switch Role:
      </label>
      
      <select
        value={currentUser.role}
        onChange={(e) => switchRole(e.target.value)}
        disabled={switching}
        style={{
          width: '100%',
          padding: '8px',
          backgroundColor: '#2c3e50',
          color: 'white',
          border: '1px solid #34495e',
          borderRadius: '4px',
          fontSize: '14px'
        }}
      >
        {availableRoles.map(role => (
          <option key={role} value={role}>
            {role}
          </option>
        ))}
      </select>

      {switching && (
        <div style={{ fontSize: '12px', color: '#aaa', marginTop: '5px' }}>
          Switching roles...
        </div>
      )}

      {error && (
        <div style={{ fontSize: '12px', color: '#ff6b6b', marginTop: '5px' }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default RoleSwitcher;